export function parseServerDate(dateInput) {
    if (!dateInput) {
        return null
    }
    if (dateInput instanceof Date) {
        return dateInput
    }
    let value = String(dateInput)
    const hasTimezone = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(value)
    if (!hasTimezone) {
        value += 'Z'
    }
    const date = new Date(value)
    return isNaN(date.getTime()) ? null : date
}

export function formatDateTime(dateInput, timeZone) {
    const date = parseServerDate(dateInput)
    if (!date) {
        return ''
    }
    try {
        return new Intl.DateTimeFormat('ru-RU', {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            timeZone: timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone
        }).format(date)
    } catch (e) {
        return date.toLocaleString('ru-RU')
    }
}

export function timeAgo(dateInput) {
    const date = parseServerDate(dateInput)
    if (!date) {
        return ''
    }
    const seconds = Math.floor((Date.now() - date.getTime()) / 1000)

    if (seconds < 60) {
        return 'только что'
    }
    const minutes = Math.floor(seconds / 60)
    if (minutes < 60) {
        return `${minutes} ${plural(minutes, 'минуту', 'минуты', 'минут')} назад`
    }
    const hours = Math.floor(minutes / 60)
    if (hours < 24) {
        return `${hours} ${plural(hours, 'час', 'часа', 'часов')} назад`
    }
    const days = Math.floor(hours / 24)
    if (days < 30) {
        return `${days} ${plural(days, 'день', 'дня', 'дней')} назад`
    }
    return date.toLocaleString('ru-RU')
}

function plural(n, one, few, many) {
    const mod10 = n % 10
    const mod100 = n % 100
    if (mod10 === 1 && mod100 !== 11) {
        return one
    }
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
        return few
    }
    return many
}
